import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { SmsSet_Appointment,SmsForClient } from 'src/classes/Automation/sms_setting';
import { BalanceGetting } from '../../../../classes/Automation/balance';
import { User } from '../../../../classes/Automation/UserApp';
import { TokenValid } from '../../../../classes/Automation/TokenValid';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { HMessage } from '../../../../classes/Automation/HMessage';
import { catchError } from 'rxjs/operators'
import { throwError } from 'rxjs';
import { ParameterSMS } from 'src/classes/Automation/Templates';
import { AdminPanel_Parameters } from 'src/classes/Automation/adminpanel_parameters';
import { NGXLogger } from "ngx-logger";

@Injectable()
export class HttpService1 {
    constructor(private http: HttpClient, private logger: NGXLogger) { }
    /*     getCustomers() : Observable<Customer[]> { 
            return this.http.get('../assets/customers.json').pipe(map(data=>{ 
                let customersList = data["customerList"]; 
                return customersList.map(function(customer:any) { 
                    return {name: customer.Name, age: customer.Age}; 
                  }); 
            })); 
        }  */

    // http://localhost:63989/Home/GetFactorial?number=
    /*   getFactorial(num: number){ 
            return this.http.get('http://localhost:63989/Home/GetFactorial?number=' + num); 
        }  */
    postData(Setting: SmsSet_Appointment) {
        const body = {
            enable: Setting.enable, daysbefore: Setting.daysbefore,
            apTime: Setting.apTime, txtmessage: Setting.txtmessage, attname: Setting.attname, attlink: Setting.attlink
        };
        return this.http.post(environment.urlserv + '/Home/PostSMSAppointment', body);
    }


    postData4Send(Setting: SmsSet_Appointment) {
        const body = {
            enable: Setting.enable, daysbefore: Setting.daysbefore,
            apTime: Setting.apTime, txtmessage: Setting.txtmessage, attname: Setting.attname, attlink: Setting.attlink
        };
        return this.http.post(environment.urlserv + '/Home/PostSMSAppointment4Send', body);
    }

    getDataBalance(user: User) {
        // const body= {username:"optimus",userpassword:"XtJQZ9hU"};
        const body = { email: user.useremail };
        return this.http.post(environment.urlserv + '/Home/GetBalanceSMS', body);
    }

    postDataBulk4Send(Setting: SmsSet_Appointment) {
        const body = {
            enable: Setting.enable, daysbefore: Setting.daysbefore,
            apTime: Setting.apTime, txtmessage: Setting.txtmessage, attname: Setting.attname, attlink: Setting.attlink
        };
        return this.http.post(environment.urlserv + '/Home/PostSMSBulk4Send', body);
    }

    postDataLogin(user: User) {
        this.logger.info('urlserv: ' + environment.urlserv)
        const body = { useremail: user.useremail };
        return this.http.post(environment.urlserv + '/Home/Login', body);
    }


    postIsTokenValid(ttoc: TokenValid) {
        const body = { token: ttoc.token };
        return this.http.post(environment.urlserv + '/Home/IsTokenValid', body)
            .pipe(
                catchError(this.handleError));
    }



    getDataBodiesForCase(user: User) {
        const body = { useremail: user.useremail };
        return this.http.post(environment.urlserv + '/Home/GetDataBodiesForCase', body);
    }


    getDataTemplates(user: User) {
        const body = { useremail: user.useremail };
        return this.http.post(environment.urlserv + '/Home/GetDataTemplates', body);
    }


    getDataAdminPanel(user: User) {
        const body = { useremail: user.useremail };
        return this.http.post(environment.urlserv + '/Home/GetDataAdminPanel', body);
    }


    getDataTags(user: User) {
        const body = { useremail: user.useremail };
        return this.http.post(environment.urlserv + '/Home/GetDataTags', body);
    }




    async postMessageHelp(hmessage: HMessage) {
        const body = { constr: hmessage.ConStr, message: hmessage.Message, keytitle: hmessage.KeyTitle };
        return await this.http.post(environment.urlserv + '/Home/PostMessage4Help', body).toPromise();
    }

    handleError(error: HttpErrorResponse) {
        console.log("HttpErrorResponse from server");
        return throwError(error);
    }

    setDataTemplates(user: User, parameters: ParameterSMS) {
        const body = {
            useremail: user.useremail, vizitReminder: parameters.vizitReminder,
            daysbefore: parameters.daysbefore, hourSend: parameters.hourSend, bodyvizit: parameters.bodyvizit,
            birthdayHourSend: parameters.birthdayHourSend,
            birthdayReminder: parameters.birthdayReminder, birthdayMethod: parameters.birthdayMethod,
            birthdayPeriodic: parameters.birthdayPeriodic, bodyBirthday: parameters.bodyBirthday,
            creatingAppointmentReminder: parameters.creatingAppointmentReminder,
            bodyCreatingAppointmentReminder: parameters.bodyCreatingAppointmentReminder,
            cancelingAppointmentReminder: parameters.cancelingAppointmentReminder,
            bodyCancelingAppointmentReminder: parameters.bodyCancelingAppointmentReminder,
            changingDateAppointmentReminder: parameters.changingDateAppointmentReminder,
            bodyChangingDateAppointmentReminder: parameters.bodyChangingDateAppointmentReminder,
            changingTimeAppointmentReminder: parameters.changingTimeAppointmentReminder,
            bodyChangingTimeAppointmentReminder: parameters.bodyChangingTimeAppointmentReminder,
            thankByRecommendationReminder: parameters.thankByRecommendationReminder,
            bodyThankByRecommendationReminder: parameters.bodyThankByRecommendationReminder,
            thankByMeetingReminder: parameters.thankByMeetingReminder,
            bodyThankByMeetingReminder: parameters.bodyThankByMeetingReminder,
            minutesAfterPay: parameters.minutesAfterPay,
            automaticClosingCash: parameters.automaticClosingCash, sendReportCash: parameters.sendReportCash,
            phone1SendReportCash: parameters.phone1SendReportCash, phone2SendReportCash: parameters.phone1SendReportCash, bId: parameters.bId, IsAddLink: parameters.isAddLink
        };
        return this.http.post(environment.urlserv + '/Home/SetDataTemplates', body);
    }


    setDataAdminPanel(user: User, parameters: AdminPanel_Parameters) {
        const body = {
            useremail: user.useremail, afterConfMsg: parameters.afterConfMsg,
            allowCancelBeforeHours: parameters.allowCancelBeforeHours, canSendSmsToInform: parameters.canSendSmsToInform, canSendSmsonCancel: parameters.canSendSmsonCancel,
            logo: parameters.logo, phoneToCall: parameters.phoneToCall,
            phoneToSendToInform1: parameters.phoneToSendToInform1, phoneToSendToInform2: parameters.phoneToSendToInform2,
            phoneToSendonCancel1: parameters.phoneToSendonCancel1, phoneToSendonCancel2: parameters.phoneToSendonCancel2,
            showCallOption: parameters.showCallOption, showCancelOption: parameters.showCancelOption
        };
        return this.http.post(environment.urlserv + '/Home/SetDataAdminPanel', body);
    }

    async SendMessageClient(sms: SmsForClient) {
        const body = {
            customerId: sms.customerId, pelephone: sms.pelephone,
            txtMessage: sms.txtMessage, businessEmail: sms.businessEmail
        };
        return await this.http.post(environment.urlserv + '/Home/SendSMSClient', body).toPromise();
    }


}